 <div class="content">
  <div *ngIf="loading" class="loading">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="101">
    </mat-progress-spinner>
  </div>

  <div class="welcome">Families</div>

  <div class="search-form">
    <mat-form-field class="search-bar" appearance="outline">
      <button class="search-icon" (click)="search($event)"  matPrefix mat-button><mat-icon>search</mat-icon></button>
      <input matInput (keyup)="checkSearchValue($event)"  (keydown.enter)="search($event)" placeholder="Search for families" (input)="searchField = $event.target.value" [value]="searchField">
      <span matSuffix > </span>
    </mat-form-field>
  </div>
  <div class="mid-control-bar">
    <div class="filter-bar-label">or use filters to find families</div>
    <!-- <mat-slide-toggle *ngIf="userTeams && userTeams.length > 0" class="teams-toggle"
    color="primary"
    [checked]="showTeamOnly"
    matTooltip="Turn off to see all patients."
    (change)="getPageOfFamilies()"
    (toggleChange)="showTeamOnly = !showTeamOnly" >
    Show just my team
  </mat-slide-toggle> -->
  </div>  
  <div class="filter-bar">
    <div *ngFor = "let filter of filters" class="filter-container">
      <family-list-filter 
        [filter]="filter" 
        [numFilters]="filters.length"
        (editingDone)="onFilterEdit()"
        (removeFilter)="onRemoveFilter($event)">
      </family-list-filter>
    </div>
    <button class="add-filter" *ngIf="filters.length < 3" (click)="addFilter()" mat-button>+ Add filter</button>
  </div>

 
  <div class="patient-list">
    <div class="patient-list-header">
      
      <form id="displayColumnsFm" [formGroup]="displayColumnsForm">
      <mat-form-field>
        <mat-select  
          [formControlName]="'selectedColumns'" 
          [(value)]="selectedColumns"
           placeholder="Displayed Columns" multiple
        >
          <mat-option *ngFor="let column of displayedColumns" [value]="column.name"  >
            {{column.displayName}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </form>
    <mat-slide-toggle [disabled]="disableControls()" (toggleChange)="toggleChangeStatus()">Show all statuses</mat-slide-toggle>
      <mat-paginator [pageSizeOptions]="[10, 25, 50]"
          showFirstLastButtons 
          aria-label="Select page of families"
          (page)="pageFamiliesList($event)"
          [length]="getNumberOfFamilies()"
          [pageIndex]="getPageNumber()"
          >
      </mat-paginator>
    </div>

      <!-- "identifier",
    "namedPrimary",
    "primaryAddress",
    "primaryPhone",
    "tags" -->
    <table class="patient-table" mat-table [dataSource]="families" matSort (matSortChange)="changeSort($event)">
      <ng-container matColumnDef="hasLateAppointments">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Running Late?</th>
        <td mat-cell  (click)="onClickFamily(family, 'hasLateAppointments')" class="center-cell" *matCellDef="let family"> <span *ngIf="family.hasLateAppointments" class="late-style"><mat-icon>notification_important</mat-icon></span> </td>
      </ng-container>
        <ng-container matColumnDef="hasLateEvaluations">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Evaluation Lateness?</th>
        <td mat-cell  (click)="onClickFamily(family, 'hasLateEvaluations')" class="center-cell" *matCellDef="let family"> <span *ngIf="family.lateEvaluationState > 0" class="late-style"><mat-icon [ngClass]="family.lateEvaluationState === 2 ? 'lateness-red' : family.lateEvaluationState === 1 ? 'lateness-yellow' : 'lateness-green'">how_to_reg</mat-icon></span> </td>
      </ng-container>
      <ng-container matColumnDef="identifier">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Family Identifier </th>
        <td  mat-cell (click)="onClickFamily(family, 'identifier')" *matCellDef="let family"> {{cleanupIdentifier(family.identifier, family.identifier)}} </td>
      </ng-container>
      <ng-container matColumnDef="namedPrimary">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Primary Contact </th>
        <td mat-cell  (click)="onClickFamily(family, 'namedPrimary')" *matCellDef="let family"> {{family.namedPrimary}} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
        <td  mat-cell (click)="onClickFamily(family, 'status')" *matCellDef="let family"> {{family.status.replaceAll('_', ' ')}} </td>
      </ng-container>
      <ng-container *ngIf="isMultiProvider()" matColumnDef="providerName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Provider </th>
        <td mat-cell  (click)="onClickFamily(family, 'name')" *matCellDef="let family"> {{getProviderName(patient)}} </td>
      </ng-container>
      <ng-container matColumnDef="teams">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Teams </th>
        <td mat-cell  (click)="onClickFamily(family, 'teams')" *matCellDef="let family"> {{family.teams}} </td>
      </ng-container>
      <ng-container matColumnDef="serviceLevel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Service Level </th>
        <td mat-cell  (click)="onClickFamily(family, 'serviceLevel')" *matCellDef="let family"> {{family.serviceLevel}} </td>
      </ng-container>
      <ng-container matColumnDef="primaryAddress">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Address </th>
        <td mat-cell (click)="onClickFamily(family, 'primaryAddress')" *matCellDef="let family"> {{family.primaryAddress}} </td>
      </ng-container>
      <ng-container matColumnDef="primaryPhone">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Phone </th>
        <td mat-cell (click)="onClickFamily(family, 'primaryPhone')" *matCellDef="let family"> {{family.primaryPhone}} </td>
      </ng-container>
      <ng-container matColumnDef="tags">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Tags </th>
        <td mat-cell (click)="onClickFamily(family, 'tags')" *matCellDef="let family"> {{family.tags}} </td>
      </ng-container>
     
      <tr mat-header-row *matHeaderRowDef="selectedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: selectedColumns;"></tr>
    </table>
    <div class="add-new-container">
      <button mat-fab color="primary" (click)="addFamily()">
     + Add new
      </button>
    </div>
  </div>

</div>
